import { Component, Input } from '@angular/core';
import { InnogyComponentRendering } from '@core/jss-models';
import {
  FormState,
  NGRX_UPDATE_ON_TYPE,
  NgrxFormsModule,
  NgrxValueConverter,
  NgrxValueConverters,
} from 'ngrx-forms';
import { AutomationIdDirective } from '@innogy/utils-automation-id';
import { CSCaptureDirective } from '@legacy/utils-contentsquare';
import { TrackFieldfocusDirective } from '@analytics/events';
import { CommonUiUtilityComponentsModule } from '@legacy/common-ui-utility-components';
import {
  ValidationClassesDirective,
  HasValueDirective,
} from '@innogy/utils-deprecated';

@Component({
  selector: 'wl-text',
  templateUrl: './text.component.html',
  styleUrls: ['./text.component.scss'],
  standalone: true,
  imports: [
    AutomationIdDirective,
    CSCaptureDirective,
    NgrxFormsModule,
    AutomationIdDirective,
    ValidationClassesDirective,
    HasValueDirective,
    TrackFieldfocusDirective,
    CommonUiUtilityComponentsModule,
  ],
})
export class TextComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() formsControl?: FormState<string | undefined | null>;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() valueConverter?: NgrxValueConverter<any, any> =
    NgrxValueConverters.default<string>();
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() placeholder = '';
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() label = '';
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() tooltip = '';
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() rendering?: InnogyComponentRendering;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() stepName?: string;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() fieldName?: string;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() hashValue?: boolean;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() sendValue? = true;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() floatingLabel? = true;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() step?: number;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() updateOn: `${NGRX_UPDATE_ON_TYPE}` = NGRX_UPDATE_ON_TYPE.CHANGE;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() skipDirtyCheck = false;
}
